/**
* @package DMV Contact Forms
* @version 1.0.0
*/

/* global params */
$(document).ready(function () {

  $('#dmv-contact-form').on('submit', function (e) {
    e.preventDefault();

    var $message = $('#dmv-contact-form .message');
    var $submit = $('#dmv-contact-form input[type=submit]');
    var form_data = $('#dmv-contact-form').serialize() + '&ajaxrequest=true';

    $message.hide();

    if ($('#dmv-contact-form input[name=name]').val() === ''
      || $('#dmv-contact-form input[name=email]').val() === ''
      || $('#dmv-contact-form textarea[name=message]').val() === '') {
      $message.html('<p class="alert alert-danger">All fields are required</p>').slideDown();
      return false;
    }

    if (!(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/.test($('#dmv-contact-form input[name=email]').val()))) {
      $message.html('<p class="alert alert-danger">Invalid email</p>').slideDown();
      return false;
    }

    $submit.prop({ disabled: true, value: 'Sending...' }).removeClass('btn-danger');

    $.ajax({
      type: 'post',
      url: params.ajax_url,
      data: form_data,
    })
      .done(function (response) {
        if (response === 'success') {
          $message.html('<p class="alert alert-success">Your message was received, we will get back to you shortly</p>').slideDown();
          e.target.reset();
        } else {
          $message.html('<p class="alert alert-danger">Something went wrong</p>').slideDown();
        }
        $submit.prop({ disabled: false, value: 'Submit' }).addClass('btn-danger');
      })
      .fail(function () {
        $message.html('<p class="alert alert-danger">Something went wrong</p>').slideDown();
        $submit.prop({ disabled: false, value: 'Submit' }).addClass('btn-danger');
      });
  });
});



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-contact-forms/index.js